import type { Action, Dispatch, TypedStartListening } from '@reduxjs/toolkit';

import {
  observeFiMigrationEligibility,
  resetFiMigrationSession,
} from '../../flux/account-discovery/fiMigrationTracking';
import { type AUTH_REDUCER_KEY, authActions } from '../../flux/auth';
import type { INSTITUTION_LOGINS_REDUCER_KEY } from '../../flux/institution-logins';
import type RootState from '../../utils/redux-store/rootState';

type RequiredState = Pick<RootState, typeof AUTH_REDUCER_KEY | typeof INSTITUTION_LOGINS_REDUCER_KEY>;
type AppStartListening = TypedStartListening<RequiredState, Dispatch<Action>>;

const sessionResetActions = new Set([
  authActions.authLogout.type,
  authActions.authSelectDataset.type,
  'LOGOUT',
  'RESET_STORE',
  'SWITCH_DATASET',
]);

export const setupFiMigrationTrackingListener = (startAppListening: AppStartListening): void => {
  startAppListening({
    predicate: (action, currentState, previousState) =>
      sessionResetActions.has(action.type) ||
      action.type === 'INIT_LISTENERS' ||
      currentState.authStore !== previousState.authStore ||
      currentState.institutionLoginsStore !== previousState.institutionLoginsStore,
    effect(action, listenerApi): void {
      if (sessionResetActions.has(action.type)) {
        resetFiMigrationSession();
        return;
      }
      observeFiMigrationEligibility(listenerApi.getState());
    },
  });
};
